<template>
  <div class="active_table">
    <div class="toolbar">
      <div class="bg_tool">
        <div class="search">
          <Select v-model="search.type" clearable style="width:100px; margin-right: 20px;text-align:center">
            <Option v-for="item in searchTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <i-input prefix="ios-search" placeholder="输入查询条件" v-model="search.name" style="width: auto" />
          <i-button type="default" style="margin-left: 1em;" @click="getData">搜索</i-button>
        </div>
        <div class="active">
          <i-button type="primary" @click="addData">添加</i-button>
          <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
        </div>
      </div>
    </div>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer style="text-align:right;margin-top: 1em"
        @on-change="pageCurrentChange($event)" @on-page-size-change="pageSizeChange($event)" />
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="登录账号" prop="username">
          <i-input v-model="formValidate.username" placeholder="输入登录账号"></i-input>
        </FormItem>
        <FormItem label="登录密码" v-if="modal.title == '添加'" prop="password">
          <i-input v-model="formValidate.password" placeholder="输入登录密码" @on-focus="passwordType = 'password'"
            :type="passwordType"></i-input>
        </FormItem>
        <FormItem label="确认登录密码" v-if="modal.title == '添加'" prop="rePassword">
          <i-input v-model="formValidate.rePassword" placeholder="输入登录密码" @on-focus="passwordType = 'password'"
            :type="passwordType"></i-input>
        </FormItem>
        <!-- 用户类型 -->
        <FormItem label="用户类型" prop="userType">
          <Select v-model="formValidate.userType" clearable>
            <Option v-for="item in userTypeList" :value="item.type" :key="item.type">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="选择企业" v-if="formValidate.userType == 'COMPANY_MANAGER'" prop="uuid">
          <Select v-model="formValidate.uuid" clearable>
            <Option v-for="item in companyList" :value="item.uuid" :key="item.uuid">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="用户名" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入用户名"></i-input>
        </FormItem>
        <FormItem label="联系号码" prop="mobile">
          <i-input v-model="formValidate.mobile" placeholder="输入手机号"></i-input>
        </FormItem>
        <FormItem label="角色" prop="roles">
          <CheckboxGroup v-model="formValidate.roles">
            <Checkbox v-for="item in roleList" :key="item.id" :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="是否启用" prop="enabled">
          <RadioGroup v-model="formValidate.enabled">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        <!-- <FormItem label="所属公司" prop="company">
          <i-input v-model="formValidate.company" placeholder="输入所属公司"></i-input>
        </FormItem>-->
        <FormItem label="邮箱" prop="mail">
          <i-input v-model="formValidate.mail" placeholder="输入邮箱地址"></i-input>
        </FormItem>
        <!-- <FormItem label="告警邮件">
          <i-switch v-model="formValidate.isSmsNotice">
            <span slot="open">开</span>
            <span slot="close">关</span>
          </i-switch>
        </FormItem> -->
        <FormItem label="车间管理配置" v-if="formValidate.userType != 'COMPANY_MANAGER'">
          <Row v-for="(item, index) in siteXmlList" :key="index">
            <i-col span="8">
              <Select v-model="item.uuid" clearable @on-change="getSiteList(index)">
                <Option v-for="jtem in companyList" :value="jtem.uuid" :key="jtem.uuid">{{ jtem.name }}</Option>
              </Select>
            </i-col>
            <i-col span="2" style="text-align: center">-</i-col>
            <i-col span="8">
              <Select v-model="item.siteId" clearable @on-change="addSiteId()">
                <Option v-for="otem in item.siteList" :value="otem.id" :key="otem.id"
                  :disabled="SiteidList.indexOf(otem.id) != -1">{{ otem.name }}</Option>
              </Select>
            </i-col>
            <i-col span="2" style="text-align: center">-</i-col>
            <i-col span="2" style="text-align: center">
              <div class="addSite" v-if="index == siteXmlList.length - 1" @click="addSitePut()">
                <Icon type="md-add" />
              </div>
              <div class="addSite" v-if="index < siteXmlList.length - 1" @click="delSiteData(index)">
                <Icon type="md-close" style="color: red" />
              </div>
            </i-col>
          </Row>
        </FormItem>

        <FormItem label="选择人脸用户">
          <Select v-model="formValidate.faceId" clearable>
            <Option v-for="item in faceUserList" :value="item.userId" :key="item.userId">{{ item.realName }}</Option>
          </Select>
        </FormItem>

        <FormItem label="接收邮件通知：">
          <CheckboxGroup v-model="formValidate.receiveNoticeEmail">
            <Checkbox v-for="(value, key) in ObjNoticeType" :key="key" :label="key">{{ value }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="接收手机短信：">
          <CheckboxGroup v-model="formValidate.receiveNoticeSms">
            <Checkbox v-for="(value, key) in ObjNoticeType" :key="key" :label="key">{{ value }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.addSite {
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 3.5px;
}

.addSite:focus {
  background-color: #ccc;
}

.toolbar {
  width: 100%;
  padding: 3em 1em 1em 1em;
  height: 7.5em;

  .bg_tool {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0.2em 1em;
    border: 1px solid #ccc;
    border-radius: 3.5px;
    justify-content: space-between;
    align-items: center;
  }
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
}
</style>

<script>
import LoadImg from "../../../components/Load_img.vue";
import { timeStamp } from "../../../util/common/date";
import { validate } from "../../../util/common/validate"; // 验证工具

export default {
  data() {
    return {
      // 表格属性
      table: {
        // 列
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "用户名",
            key: "username",
            align: "center"
          },
          {
            title: "姓名",
            key: "name",
            align: "center"
          },
          // {
          //   title: "公司",
          //   key: "company",
          //   align: "center"
          // },
          {
            title: "是否启用",
            key: "enabled",
            align: "center",
            render: (h, params) => {
              return h("div", {}, params.row.enabled ? "已启用" : "未启用");
            }
          },
          {
            title: "手机号",
            key: "mobile",
            align: "center"
          },
          {
            title: "邮箱地址",
            key: "mail",
            align: "center",
          },
          // {
          //   title: "用户类型",
          //   key: "userType",
          //   align: "center",
          //   render: (h, params) => {
          //     return h(
          //       "div",
          //       {},
          //       params.row.userType == "SYSTEM_MANAGER"
          //         ? "系统管理员"
          //         : params.row.userType == "PARK_MANAGER" ? "园区管理员" : "企业管理员"
          //     );
          //   }
          // },
          {
            title: "创建时间",
            key: "createDate",
            align: "center"
          },
          {
            title: "操作",
            key: "action",
            width: 150,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        let roles = params.row.roles.map(value => {
                          return parseInt(value);
                        });
                        this.formValidate = {
                          company: params.row.company,
                          enabled: params.row.enabled + "",
                          job: params.row.job,
                          mobile: params.row.mobile,
                          name: params.row.name,
                          mail: params.row.mail,
                          userType: params.row.userType,
                          username: params.row.username,
                          uuid: params.row.uuid,
                          faceId: params.row.faceId,
                          roles: roles,
                          id: params.row.id,
                          isSmsNotice: params.row.isSmsNotice || false,
                          smsNoticeConfig: {
                            filterSites: params.row.smsNoticeConfig
                              ? params.row.smsNoticeConfig.filterSites
                              : ""
                          },
                          receiveNoticeEmail: params.row.receiveNoticeEmail ? JSON.parse(params.row.receiveNoticeEmail) : [],
                          receiveNoticeSms: params.row.receiveNoticeSms ? JSON.parse(params.row.receiveNoticeSms) : [],
                        };
                        this.siteXmlList = [];
                        let temp = params.row.smsNoticeConfig
                          ? params.row.smsNoticeConfig.filterSitesInfo
                          : [];
                        temp = temp || [];
                        this.SiteidList = temp.map((res, index) => {
                          this.siteXmlList.push({
                            siteList: [],
                            siteId: res.id,
                            uuid: res.uuid
                          });
                          this.getSiteList(index);
                          return res.id;
                        });
                        if (this.siteXmlList.length == 0) {
                          this.siteXmlList = [
                            {
                              siteList: [],
                              siteId: null,
                              uuid: null
                            }
                          ];
                        }
                        //console.log(this.siteXmlList);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        // 数据
        data: [],
        // 加载开关
        loading: false
      },
      total: null,
      pageCurrent: 1,
      pageSize: 10,
      // 查询属性
      search: {
        type: null,
        name: null
      },
      searchTypeList: [{ id: 1, name: "用户名" }, { id: 2, name: "真实姓名" }],
      // 对话框属性
      modal: {
        show: false,
        title: null
      },
      // 表单数据
      formValidate: {
        username: "",
        rePassword: "",
        password: "",
        name: "",
        mobile: "",
        mail: "",
        enabled: null,
        company: "",
        job: "",
        roles: [],
        userType: "",
        isSmsNotice: false,
        smsNoticeConfig: {
          filterSites: ""
        },
        receiveNoticeEmail: [],
        receiveNoticeSms: [],
        uuid: "",
        faceId: "",
      },
      // 验证
      ruleValidate: {
        username: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value == "admin") {
                callback("不能使用admin作为用户名");
              } else {
                callback();
              }
            }
          }
        ],
        password: [{ required: true, message: "不能为空", trigger: "blur" }],
        rePassword: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("不能为空");
              } else if (this.formValidate.password != value)
                callback("两次密码不一样");
              else callback();
            }
          }
        ],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        mobile: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("不能为空");
              } else if (!validate.phone(value)) callback("手机号格式错误");
              else callback();
            }
          }
        ],
        enabled: [{ required: true, message: "请选择", trigger: "change" }],
        // company: [{ required: true, message: "不能为空", trigger: "blur" }],
        // job: [{ required: true, message: "不能为空", trigger: "blur" }],
        roles: [
          {
            required: true,
            message: "不能为空",
            type: "array"
          }
        ],
        userType: [{ required: true, message: "请选择", trigger: "change" }],
        uuid: [{ required: true, message: "请选择", trigger: "change" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      // 角色枚举列表
      roleList: [],
      // 企业列表
      companyList: [],
      // 用户列表枚举
      userTypeList: [
        {
          type: "COMPANY_MANAGER",
          name: "企业管理员"
        },
        {
          type: "PARK_MANAGER",
          name: "园区管理员"
        },
        {
          type: "SYSTEM_MANAGER",
          name: "系统用户"
        }
      ],
      // 人脸用户
      faceUserList: [],
      // 站点配置列表
      siteXmlList: [
        {
          siteList: [],
          siteId: null,
          uuid: null
        }
      ],
      // 最终配置
      SiteidList: [],
      // 控制表单填充
      passwordType: "text",
      ObjNoticeType: {},
    };
  },
  components: {
    LoadImg
  },
  created() {
    // 数据初始化
    this.getNoticeType();
    this.getData();
    this.getEnum();
    this.getCompany();
    this.getFaceUser();
  },
  methods: {
    // 获取企业列表数据
    getData() {
      this.loading = true; // 开启loading...
      let searchObj = {};
      if (this.search.type == 1) {
        searchObj = { username: this.search.name };
      } else if (this.search.type == 2) {
        searchObj = { name: this.search.name };
      }
      this.$api.System.getUserList(
        {
          pageCurrent: this.pageCurrent,
          pageSize: this.pageSize,
          content: searchObj,
        },
        ["uuids", "system"]
      )
        .then(res => {
          if (res.code == 0) {
            let data = res.data.list;
            for (let i = 0, length = data.length; i < length; i++) {
              data[i].createDate = timeStamp(data[i].createDate);
            }
            this.table.total = res.data.total;
            this.table.data = data;
            this.loading = false; // 关闭
            this.$Message.success("加载完成");
          } else {
            this.loading = false; // 关闭
            this.$Notice.warning({
              title: "加载失败",
              desc: res.message || "请联系管理员"
            });
          }
        })
        .catch(err => {
          this.loading = false; // 关闭
        });
    },
    // 添加初始化表单
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        username: "",
        rePassword: "",
        password: "",
        name: "",
        mobile: "",
        mail: "",
        enabled: null,
        company: "",
        job: "",
        roles: [],
        userType: "",
        isSmsNotice: false,
        smsNoticeConfig: {
          filterSites: ""
        },
        receiveNoticeEmail: [],
        receiveNoticeSms: [],
        faceId: "",
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    // 删除数据操作
    delData() {
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.System.postUserDel({ content: { id: id } }, [
          "uuids",
          "system"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    // 表格增改操作
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.formValidate.smsNoticeConfig.filterSites = this.SiteidList.join();
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.System.postUserAdd({ content: params }, [
              "uuids",
              "system"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.System.postUserEdit({ content: params }, [
              "uuids",
              "system"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 获取枚举 角色
    getEnum() {
      this.$api.System.getUserRoleEnum({ paging: false }, ["uuids", "system"]).then(res => {
        if (res.code == 0) {
          this.roleList = res.data;
        }
      });
    },
    // 获取企业列表
    getCompany() {
      this.$api.A_Company.getCompanyList({ paging: false }, ["uuids", "system"]).then(
        res => {
          if (res.code == 0) {
            this.companyList = res.data;
            // console.log(this.companyList);
          }
        }
      );
    },
    // 获取通知类型
    getNoticeType() {
      this.$api.Deploy.getNoticeType(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.ObjNoticeType = res.data;
        } else {
          this.$Notice.warning({
            title: "获取通知类型枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取站点列表
    getSiteList(index) {
      let data = this.siteXmlList[index];
      this.$api.Deploy.getSiteList({ content: { uuid: data.uuid } }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteXmlList[index].siteList = res.data.list;
        }
      });
    },
    // 获取人脸用户列表
    getFaceUser() {
      this.$api.A_User.getFaceUserList({ content: { uuid: '--' } }, [null, "company"]).then(
        res => {
          if (res.code == 0) {
            this.faceUserList = res.data;
            //console.log(this.faceUserList);
          }
        }
      );
    },
    // 添加栏位
    addSitePut() {
      this.siteXmlList.push({
        siteList: [],
        siteId: null,
        uuid: null
      });
    },
    // 删除栏位
    delSiteData(index) {
      this.siteXmlList.splice(index, 1);
    },
    // 组织站点id列表
    addSiteId() {
      this.SiteidList = this.siteXmlList
        .filter(res => {
          return !!res.siteId;
        })
        .map(res => {
          return res.siteId;
        });
    },
    // img上传组件回调
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.imgUrl = url;
    },
    // img删除回调
    imgLoadDel() {
      this.formValidate.imgUrl = null;
    },
    // 页码切换
    pageCurrentChange(msg) {
      this.pageCurrent = msg;
      this.getData();
    },
    pageSizeChange(msg) {
      this.pageSize = msg;
      this.getData();
    }
  }
};
</script>